// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1ezhc","col":"CardReaderDesc_col__1znlC","label":"CardReaderDesc_label__2i4QT"};